import { FilterRequest } from "../filters/filters.types";

/** Bir ürün isteğinin filtre imzası.
 *
 *  Hem GenericProductsPage'in "bu isteği zaten attım mı" kontrolü hem de slice'ın
 *  "Redux'taki liste hangi filtreyle dolduruldu" kaydı BU fonksiyonu kullanır —
 *  iki taraf farklı normalizasyon yaparsa cache guard sessizce yanlış listeyi
 *  ekranda bırakır.
 *
 *  Array değerleri sıralanır: aynı filtre setinin farklı sırayla gelmesi
 *  (ör. [3,1] vs [1,3]) yeni bir istek gibi görünmesin. */
export const buildProductsRequestKey = (
  filters?: FilterRequest | Record<string, unknown>,
): string => {
  if (!filters) return "";
  const normalized = Object.fromEntries(
    Object.entries(filters).map(([k, v]) =>
      Array.isArray(v) ? [k, [...v].sort((a, b) => a - b)] : [k, v],
    ),
  );
  return JSON.stringify(normalized);
};
